export const homeOwners = {
  name: "Home Owners DIY Guide",
  excerpt: "Home Improvement Blog",
  image: "diy-guide.jpg",
  localUrl: "home-owners",
  url: "https://www.homeownersdiyguide.com",
  description:
    "Homeowners DIY Guide is a blogging site dedicated to the upkeep of ones home. It talks about various DIY projects, along with helpful advice to keep your home in tip top shape.",
  challenge:
    "The biggest challenge we had when building this site was speed. Google was beginning to place more SEO weight on their core web vitals, and we wanted to make sure that we followed best practices. This meant utilizing some new technologies, and working hard to make little optimizations.",
  solution:
    "In the end, we moved away from Wordpress and migrated to a static blogging platform. This sacrificed a bit of ease of use for the end user, but made it much easier to build a performant site. Since we manage the site ourselves, this was an easy trade-off to make. We continue to suppor the site with SEO and marketing efforts.",
  tech: ["React", "Gatsby", "TailwindCSS"],
  images: [
    "simpleLeadTracker.webp",
    "simpleLeadTracker.webp",
    "simpleLeadTracker.webp",
  ],
}
